import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'peps-toggle',
	imports: [

	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './toggle.component.html',
})
export class ToggleComponent {
	@Input() checked: boolean = false;
	@Output() checkedChange = new EventEmitter<boolean>();

	toggle() {
		this.checked = !this.checked;
		this.checkedChange.emit(this.checked);
	}
}
